import {
  Building2, Sparkles, Layers, Brush, HardHat, Landmark, Wrench, Leaf, ArrowRight,
} from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "../constants";

const SERVICES = [
  { icon: Building2, slug: "buero", title: "Büro- & Unterhaltsreinigung", desc: "Regelmäßige professionelle Reinigung von Büros, Arbeitsplätzen, Sanitärbereichen und Gemeinschaftsflächen." },
  { icon: Sparkles, slug: "glas", title: "Glas- & Fensterreinigung", desc: "Professionelle Reinigung von Fenstern, Glasflächen und Verglasungen." },
  { icon: Layers, slug: "treppenhaus", title: "Treppenhausreinigung", desc: "Zuverlässige Pflege von Treppenhäusern und gemeinschaftlich genutzten Bereichen." },
  { icon: Brush, slug: "grund", title: "Grundreinigung", desc: "Intensive Reinigung stark beanspruchter oder länger nicht grundgereinigter Flächen." },
  { icon: HardHat, slug: "bau", title: "Baureinigung", desc: "Professionelle Reinigung während und nach Bau-, Umbau- und Renovierungsmaßnahmen." },
  { icon: Landmark, slug: "fassade", title: "Fassadenreinigung", desc: "Professionelle Pflege und Reinigung geeigneter Fassadenflächen." },
  { icon: Wrench, slug: "hausmeister", title: "Hausmeisterservice", desc: "Unterstützung bei der regelmäßigen Betreuung von Gewerbe- und Immobilienobjekten." },
  { icon: Leaf, slug: "aussen", title: "Außenanlagenpflege", desc: "Pflege und Sauberhaltung von Außenbereichen und Grundstücksflächen." },
];

export const Services = () => {
  const request = (title) => {
    window.dispatchEvent(new CustomEvent("emt:prefill-service", { detail: title }));
    scrollToId("kontakt");
  };

  return (
    <section id="leistungen" className="bg-white py-16 md:py-24" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Chapter number="01" label="Leistungen" />
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink max-w-2xl">
            Alle Reinigungsleistungen für Ihr Objekt – aus einer Hand
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={Math.min(i * 0.06, 0.3)}>
              <article
                className="group h-full flex flex-col bg-white border border-gray-200 rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(11,25,44,0.25)] hover:border-brand/40"
                data-testid={`service-card-${s.slug}`}
              >
                <div className="w-12 h-12 rounded-xl bg-ice flex items-center justify-center mb-5 transition-colors duration-300 group-hover:bg-brand">
                  <s.icon className="w-6 h-6 text-brand transition-colors duration-300 group-hover:text-white" strokeWidth={1.8} />
                </div>
                <h3 className="font-heading text-xl font-medium text-ink leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-mutedtext leading-relaxed flex-1">{s.desc}</p>
                <button
                  onClick={() => request(s.title)}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand hover:gap-3 transition-all duration-200 self-start"
                  data-testid={`service-cta-${s.slug}`}
                >
                  Angebot anfragen
                  <ArrowRight className="w-4 h-4" />
                </button>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
